import React from 'react';
import Table from 'src/ui/library/Table';
import intl from 'react-intl-universal';

class EntityTable extends React.Component {
  state = {
    showDelete: false,
    rowsSelected: [],
  };

  handleDelete = () => {
    // call api to delete entry
    const { deleteRowsFn } = this.props;
    const { rowsSelected } = this.state;
    //alert('we are deleting a row - future API request here');
    deleteRowsFn(rowsSelected);
  };

  handleAdd = () => {
    // call api to add entry
    const { addNewRowFn } = this.props;
    //alert('we are adding a row - future API request here');
    addNewRowFn();
  };

  tableFooter = () => {
    const { cancelRowsFn } = this.props;
    const { showDelete } = this.state;

    return (
      <section className="table-footer">
        {showDelete ? (
          <React.Fragment>
            <a onClick={this.handleDelete} key={'delete'}>
              {intl.get('controls.tables.delete')}
            </a>
            <a onClick={cancelRowsFn()} key={'cancel'}>
              {intl.get('controls.tables.cancel')}
            </a>
          </React.Fragment>
        ) : (
          <a onClick={this.handleAdd}>{intl.get('controls.tables.addRow')}</a>
        )}
      </section>
    );
  };

  onTableChange = (actionType, data) => {
    if (actionType === 'rowSelected') {
      const { selectedRows } = data.model;

      this.setState({
        showDelete: selectedRows.length ? true : false,
        rowsSelected: selectedRows,
      });
    }
  };

  render() {
    const {
      label,
      setUpdateModelFn,
      addNewRowFn,
      deleteRowsFn,
      elementActions,
      cancelRowsFn,
      setTableModelFn,
      setCancelSelectedRows,
      setUpdateColumnFn,
      ...otherProps
    } = this.props;

    return (
      <div className={'entity-table'}>
        <span className={'table-label'}>{label}</span>
        <Table
          footer={this.tableFooter}
          updateModel={setUpdateModelFn}
          setTableModel={setTableModelFn}
          updateColumn={setUpdateColumnFn}
          onTableChange={this.onTableChange}
          cancelSelectedRows={setCancelSelectedRows}
          {...otherProps}
          hardDisplay={false}
        />
      </div>
    );
  }
}

export default EntityTable;



// WEBPACK FOOTER //
// ./src/ui/library/ContentParser/controls/EntityTable/EntityTable.js